export const NetworkError = 'NetworkError';
export const UnknownError = 'UnknownError';
export const ApiResponseShapeError = 'ApiResponseShapeError';
export const NotFoundError = 'NotFoundError';
export const NotAuthorizedError = 'NotAuthorizedError';
export const ForbiddenError = 'ForbiddenError';
export const ConflictError = 'ConflictError';
export const BadRequestError = 'BadRequestError';
export const GoneError = 'GoneError';
export const InvalidTokenError = 'InvalidTokenError';
